export const provisioningTerminologyZhCN = {
  provisioning: {
    title: '自动装机',
    description: '管理系统镜像、装机模板、装机网络、安装任务和安全预检查结果',
    safetyNotice: '当前阶段只开放安全预检查和配置清单核验，不启用 DHCP/TFTP/iPXE，不重载服务，不重启服务器，不擦盘。',
    simpleWorkbenchKicker: '装机工作台',
    simpleWorkbenchTitle: '简单装机工作台',
    simpleWorkbenchDescription: '日常运维流程：先在库存确认服务器并核对 MAC，再选择系统和目标网卡，最后做安全预检查。真实 DHCP/PXE 执行仍然关闭。',
    simpleStepInventory: '库存确认',
    simpleStepInventoryDesc: '确认服务器 SN、BMC、网卡 MAC、机房和机柜位置。',
    simpleStepSelectOS: '选择系统',
    simpleStepSelectOSDesc: '选择系统镜像、装机模板和装机网络。',
    simpleStepMacCheck: 'MAC 核对',
    simpleStepMacCheckDesc: '目标 MAC 必须来自库存/自动发现；不一致就不允许安装。',
    simpleStepDryRun: '安全预检查',
    simpleStepDryRunDesc: '先生成装机配置清单，并检查 Agent、VLAN、DHCP 窗口和 MAC 白名单。',
    simpleCreateSingleInstall: '创建单台装机任务',
    simpleCreateBatchInstall: '创建批量装机计划',
    simpleNoRealExecution: '当前不会启动真实 DHCP/TFTP/iPXE，也不会重启服务器或擦盘。',
    simpleReadyServers: '待确认服务器',
    simplePxeNics: '可装机网卡',
    simpleOnlineAgents: '在线 Agent',
    simpleImagesProfiles: '镜像 / 模板',
    simpleSafetyTitle: '装机安全规则',
    simpleRuleMacMatch: '安装前必须二次核对目标 MAC；和库存/自动发现不一致就终止。',
    simpleRuleOneTimeBoot: '如果服务器不是默认从装机网卡启动，真实执行前必须通过 BMC/IPMI 设置一次性网卡启动，再重启。',
    simpleRuleFailStop: '安装失败、超时或 Agent 断联时，任务必须终止，不能反复执行危险动作。',
    simpleRuleTemporaryDHCP: 'DHCP/PXE 只能在安装窗口临时开启；成功、失败或超时后必须自动关闭并清理白名单。',
    installSafetyStatusTitle: '装机安全状态',
    installSafetyStatusDescription: '给运维看的状态：系统当前是否会真的开 DHCP/PXE、重启服务器或执行危险任务。',
    installSafetyStatusMessage: '安全状态已同步，真实装机执行仍然锁定。',
    installSafetyLocked: '安全锁定',
    installSafetyNeedsReview: '需要检查',
    installSafetySynced: '状态已同步',
    installSafetyFallback: '状态待确认',
    plainMacCheck: 'MAC 校验',
    plainMacCheckDesc: '装机任务必须使用库存/自动发现里的目标 MAC。',
    plainPxeExecution: '真实 PXE 执行',
    plainPxeExecutionDesc: '当前不允许真正启动 DHCP/TFTP/iPXE。',
    plainDhcpWindow: 'DHCP/PXE 临时窗口',
    plainDhcpWindowDesc: '没有装机窗口时，DHCP/PXE 应保持关闭。',
    plainDangerTasks: '危险执行任务',
    plainDangerTasksDesc: '真实改网络、清理网络或执行中的危险任务数量。',
    enabled: '开启',
    disabled: '关闭',
    advancedDiagnostics: '展开排障信息',
    advancedDiagnosticsDesc: '下面是开发和排障使用的底层安全计数，日常装机不用看。',
    installableInventoryTitle: '库存可装机服务器',
    installableInventoryDescription: '从库存和自动发现结果汇总可装机服务器，重点核对 SN、BMC、目标 MAC 和 Agent 在线状态。',
    servers: '台装机目标',
    serverIdentity: '服务器',
    nicMac: '网卡 / MAC',
    macVerified: 'MAC 已核对',
    verified: '已核对',
    pendingVerify: '待核对',
    latestInstall: '最近装机',
    installAllowed: '允许装机',
    startInstall: '发起装机',
    manualBootRequired: '需确认启动网卡',
    yes: '是',
    no: '否',
    inventoryBlockedNoMac: '缺少目标 MAC',
    inventoryBlockedAgentOffline: 'Agent 不在线',
    inventoryBlockedMissingConfig: '缺少系统镜像或装机模板',
    inventoryBootOverrideDefaultReason: '该网卡未标记为默认可装机网卡，后续真实执行前需要通过 BMC/IPMI 设置一次性网卡启动',
    osImages: '系统镜像',
    pxeProfiles: '装机模板',
    networks: '装机网络',
    installBatches: '装机批次',
    installTasks: '装机任务',
    logs: '装机日志',
    checks: '网络检查',
    allowlist: 'MAC 白名单',
    createImage: '新建镜像',
    createProfile: '新建装机模板',
    createNetwork: '新建装机网络',
    configureNetwork: '配置装机网络',
    createBatch: '新建装机批次',
    createTask: '新建装机任务',
    dryRunNetwork: '网络安全预检查',
    installDryRun: '安装安全预检查',
    pxeRenderDryRun: 'PXE 配置清单预检查',
    createBootPlan: '生成启动计划',
    bootPlanLatest: '最近生成的启动计划',
    bootPlanReadonlyNotice: '只生成一次性 PXE 启动计划，不执行 IPMI/Redfish，不重启服务器。',
    bootPlanOneTimeBoot: '一次性启动',
    bootPlanExecution: '真实执行',
    bootPlanNoExecution: '当前只是计划，未执行 BMC 命令，未重启，未启动 DHCP/PXE。',
    bootPlanReady: '启动计划已生成',
    bootPlanCreated: '启动计划已生成，未执行真实操作',
    bootPlanTooltip: '生成 BMC 一次性 PXE 启动预检查计划',
    bootPlanBlockedStatus: '只有未开始执行的装机任务才能生成启动计划',
    bootPlanBlockedNoNic: '缺少自动发现网卡，不能核对 MAC',
    bootPlanBlockedNoBmc: '缺少 BMC IP，不能生成启动计划',
    installFlowTitle: '装机流程总览',
    installFlowDescription: '用运维能看懂的方式展示每台机器当前走到哪一步：库存、MAC、启动计划、真实执行。',
    flowInventory: '库存录入',
    flowInventoryDone: '已关联库存 / 自动发现',
    flowInventoryMissing: '未关联库存，先录入服务器',
    flowMacCheck: 'MAC 核对',
    flowMacDone: '目标 MAC 已绑定',
    flowMacMissing: '缺少目标 MAC 或网卡',
    flowBootPlan: '启动计划',
    flowBootPlanDone: '一次性 PXE 启动计划已生成',
    flowBootPlanReady: '可生成计划，尚未真实执行',
    flowRealInstall: '真实装机',
    flowRealInstallLocked: '当前锁定，未启动 DHCP/PXE/IPMI',
    tasks: '个任务',
    taskWizardSafetyNotice: '当前只是创建装机任务和 MAC 白名单记录，不会启动 DHCP/TFTP/iPXE，不会重启服务器，不会擦盘。',
    taskWizardStepServer: '选服务器 / MAC',
    taskWizardStepOS: '选系统镜像',
    taskWizardStepConfirm: '确认安全预检查',
    taskWizardServerTitle: '第一步：选择要装机的服务器',
    taskWizardServerDesc: '从库存/自动发现里选择网卡，系统会自动带出 MAC 和 BMC IP。MAC 不一致就不能继续。',
    taskWizardOSTitle: '第二步：选择系统和装机配置',
    taskWizardOSDesc: '选择系统镜像、装机模板和装机网络。当前仍然只创建任务，不启动真实 PXE 服务。',
    taskWizardConfirmTitle: '第三步：确认后创建任务',
    taskWizardConfirmDesc: '确认目标 MAC、BMC、系统镜像和 Agent。保存后进入待执行/安全预检查阶段。',
    taskWizardConfirmSafety: '保存后不会真实装机。后续还需要生成启动计划和 PXE 配置清单预检查，确认无误后才能设计真实执行。',
    taskWizardMissingRequired: '请先补全当前步骤的必填信息',
    previousStep: '上一步',
    nextStep: '下一步',
    batchDryRun: '批次安全预检查',
    batchDryRunConfirm: '确认排队批次 PXE 配置清单预检查？此操作仅生成临时配置清单，不启动 DHCP/TFTP/iPXE，不擦盘。',
    viewBatchDetail: '查看详情',
    batchDetail: '批次详情',
    batchSummary: '批次概要',
    batchDetailReadonlyNotice: '只读审计视图：不会启动 DHCP/TFTP/iPXE，不会擦盘。',
    latestDryRun: '最近安全预检查',
    agentTaskId: 'Agent 任务 ID',
    manifestPath: '配置清单路径',
    renderedFileCount: '生成文件数',
    renderedFiles: '生成文件',
    safetyFlags: '安全标记',
    noLatestDryRun: '当前批次还没有关联的 Agent 安全预检查结果。',
    activationPreflight: '装机窗口预检',
    activationPreflightNotice: '只检查是否满足开装机窗口的条件，不启动 DHCP/TFTP/iPXE。',
    activationPreflightPassed: '装机窗口预检通过',
    activationPreflightFailed: '装机窗口预检未通过',
    activationPreflightMissingHash: '缺少配置清单校验值，不能预检',
    hostBindPreflight: '装机网络绑定预检',
    hostBindPreflightNotice: '只检查 Agent 网卡、VLAN、绑定 IP 和临时授权条件，不执行真实网络变更，不启动 DHCP/TFTP/iPXE。',
    hostBindPreflightSummary: '装机网络绑定预检概要',
    hostBindPreflightPassed: '装机网络绑定预检通过',
    hostBindPreflightFailed: '装机网络绑定预检未通过',
    createHostBindDryRunLease: '创建临时网络授权记录',
    hostBindDryRunLease: '临时网络授权记录',
    hostBindDryRunLeaseNotice: '只创建审计/协作记录，不创建 Agent 任务，不修改网卡，不启动 DHCP/TFTP/iPXE。',
    hostBindDryRunLeaseConfirm: '确认创建临时网络授权记录？此操作只写入审计记录，不会创建 Agent 任务，不会修改远端网卡或启动 DHCP/TFTP/iPXE。',
    hostBindDryRunLeaseCreated: '临时网络授权记录已创建',
    hostBindLeases: '临时网络授权',
    hostBindLeaseReadonlyNotice: '只读历史视图，不提供真实执行/清理操作。',
    hostBindGuardTitle: '装机网络安全状态',
    hostBindGuardDescription: '锁定模式：主控和页面不开放真实执行/清理，不创建 Agent 执行任务，不修改网卡，不启动 DHCP/TFTP/iPXE。',
    contractOnlyLocked: '锁定模式',
    visibleActiveBindLeases: '当前可见活跃授权',
    visibleApplyCleanupTaskRefs: '当前可见执行/清理任务引用',
    backendAuthoritative: '后端权威计数',
    visibleFallback: '可见数据降级',
    guardStatusLoadFailed: '安全状态加载失败',
    authoritativeActiveBindLeases: '数据库活跃授权',
    authoritativeDryRunBindLeases: '数据库预检查授权',
    authoritativeApplyCleanupTaskRefs: '数据库执行/清理任务引用',
    authoritativeApplyCleanupAgentTasks: '数据库执行/清理 Agent 任务',
    pendingRunningApplyCleanupTasks: '等待/执行中的危险任务',
    applyCleanupApiLocked: '真实执行/清理 API 锁定',
    agentTaskCreationEnabled: 'Agent 执行任务创建开关',
    uiApplyCleanupActions: '页面真实执行/清理入口',
    supportedBindMethods: '支持的网络绑定方式',
    applyCleanupTaskTypes: '执行/清理任务类型',
    applyCleanupTaskRefs: '执行/清理任务引用',
    notExposed: '未开放',
    reviewRequired: '需要复核',
    none: '无',
    leaseNetworkFilter: '按装机网络过滤',
    leaseStatusFilter: '按授权状态过滤',
    leaseActivity: '授权活跃性',
    activeLease: '活跃',
    inactiveLease: '非活跃/过期',
    applyStrategy: '执行策略',
    preflightCheckCount: '预检项数量',
    activationLocked: '装机执行锁定',
    bindApplyEnabled: '网络绑定执行开关',
    bindMethod: '绑定方式',
    check: '检查项',
    installTaskId: '装机任务 ID',
    discoveryResultId: '发现结果 ID',
    discoveryNicId: '发现网卡 ID',
    createAllowlist: '绑定 MAC 白名单',
    viewLogs: '查看日志',
    viewChecks: '查看检查',
    viewAllowlist: '查看白名单',
    name: '名称',
    family: '系统类型',
    version: '版本',
    arch: '架构',
    bootMode: '启动模式',
    imageUrl: '镜像地址',
    checksum: '校验值',
    storageBackend: '存储后端',
    pxeProfile: '装机模板',
    osImage: '系统镜像',
    partitionStrategy: '分区策略',
    networkStrategy: '网络策略',
    installTemplate: '安装模板 JSON',
    postInstallScript: '安装后脚本',
    vlan: 'VLAN',
    cidr: 'CIDR',
    bindIp: 'Agent 绑定 IP',
    gateway: '网关',
    dhcpRange: 'DHCP 范围',
    dhcpStart: 'DHCP 起始地址',
    dhcpEnd: 'DHCP 结束地址',
    dnsServers: 'DNS',
    agentInterface: 'Agent / 网卡',
    interfaceName: '网卡名称',
    targetMac: '目标 MAC',
    targetBmc: '目标 BMC IP',
    targetCount: '目标数量',
    maxParallel: '并发数量',
    macHash: 'MAC 校验哈希',
    manifestHash: '配置清单哈希',
    sourceRef: '来源编号',
    batchTargets: '批次目标',
    addTarget: '添加目标',
    batchSafetyNotice: '当前批量装机只创建待审批批次，不启用 DHCP/TFTP/iPXE，不触发 Agent 真实执行，不擦盘。',
    discoveryResult: '发现服务器',
    discoveryNic: '发现网卡',
    selectDiscoveryResult: '选择自动发现结果',
    selectDiscoveryNic: '选择装机网卡',
    primaryNic: '主网卡',
    pxeEligible: '可装机',
    pxeNicOverride: '需确认',
    pxeNicOverrideReason: '装机网卡选择原因',
    pxeNicOverrideRequired: '该网卡未被自动判定为可装机网卡，请填写确认原因',
    pxeNicOverrideNotice: '当前选择的网卡未被自动判定为可装机网卡。商业 IDC 场景允许人工确认，但会写入审计字段。',
    deviceId: '设备 ID',
    expires: '过期时间',
    expiresMinutes: '有效分钟数',
    phase: '阶段',
    level: '级别',
    message: '消息',
    payload: '详情数据',
    invalidJson: 'JSON 内容不合法',
    queued: '任务已排队',
    activeRejected: '真实执行模式暂不开放，请使用关闭或安全预检查模式。',
    networkConfigNotice: '仅保存 Master 配置，不启动 DHCP/TFTP/iPXE，不修改交换机或远端服务器。',
    manifestHint: '如果日志详情里出现配置清单路径和哈希，可用脚本做远程只读核验。',
    statusPending: '等待中',
    statusRunning: '执行中',
    statusSucceeded: '成功',
    statusFailed: '失败',
    statusCanceled: '已取消',
    statusExpired: '已过期',
    statusActive: '启用',
    statusDisabled: '停用',
    statusDeprecated: '已废弃',
    statusDryRun: '安全预检查',
    statusDraft: '草稿',
    statusDryRunPassed: '预检通过',
    statusCleanupPending: '等待清理',
    statusCleaned: '已清理',
    statusRevoked: '已撤销',
    statusPendingApproval: '待审批',
    statusApproved: '已审批',
    boolYes: '是',
    boolNo: '否',
    checkPassed: '通过',
    checkFailed: '失败',
    networkDhcp: 'DHCP 自动获取',
    networkStatic: '静态 IP',
    bootBios: 'BIOS',
    bootUefi: 'UEFI',
  },
}
